/* Helper único de chamada ao backend, usado por todos os outros arquivos
   de services/*.js -- antes cada arquivo tinha sua própria cópia de
   `apiFetch` + `supabase.auth.getSession()` pra montar o header
   Authorization; agora o token vem do login próprio (ver services/auth.js),
   guardado no localStorage, sem precisar de chamada assíncrona nenhuma
   pra ler. */

const API_URL = process.env.REACT_APP_API_URL;
const CHAVE_AUTH = 'essensials_auth';

export function lerAuth() {
  try {
    return JSON.parse(localStorage.getItem(CHAVE_AUTH));
  } catch {
    return null;
  }
}

export function salvarAuth(auth) {
  localStorage.setItem(CHAVE_AUTH, JSON.stringify(auth));
}

export function limparAuth() {
  localStorage.removeItem(CHAVE_AUTH);
}

/* token puro, pra quem precisa montar a própria requisição (upload de
   arquivo com FormData, download de blob) em vez de usar apiFetch */
export function obterToken() {
  return lerAuth()?.token ?? null;
}

/* dispara um evento global quando o backend recusa o token (expirado,
   usuário desativado, etc.) -- App.js escuta isso pra derrubar a sessão e
   voltar pro login, sem precisar de um listener tipo onAuthStateChange */
function tratarNaoAutorizado() {
  limparAuth();
  window.dispatchEvent(new Event('essensials:unauthorized'));
}

export async function apiFetch(path, options = {}) {
  const token = obterToken();

  const response = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });

  if (response.status === 401) tratarNaoAutorizado();
  if (response.status === 204) return null;
  const json = await response.json();
  if (!response.ok) throw new Error(json.error || 'Erro na requisição');
  return json;
}

export { API_URL };
